import React, { useState, useEffect } from "react";
// import { Modal } from "antd";
import { Modal, CircularProgress, Typography, Slider } from "@mui/material";
import Table from "@mui/material/Table";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";


import "./leftbar.css";


import "jspdf-autotable";






const Datatable = ({
    selectedMarker,
    formatDate,
    sortConfig,
    handleSort, 
    datalogs,
    
}) => {
  
    const sortedDatalogs = [...datalogs].sort((a, b) => {
        const key = Object.keys(sortConfig).find(
          (k) => sortConfig[k].direction !== "asc"
        );
        if (!key) return 0;
        const direction = sortConfig[key].direction === "asc" ? 1 : -1;
        if (a[key] < b[key]) return -1 * direction;
        if (a[key] > b[key]) return 1 * direction;
        return 0;
      });
  

  

  return (
   
       <>
                    <h2>Datalog for {selectedMarker.wellId}</h2>
                    <p>
                      {" "}
                      <strong>Location:</strong> {selectedMarker.union_} ,
                      {selectedMarker.upazilla}, {selectedMarker.district},{" "}
                      {selectedMarker.division}
                    </p>{" "}
                    <br />
                    <p>
                      Click on the cell to sort it ASC
                      <FaArrowUp /> or DESC
                      <FaArrowDown />
                    </p>
                    <TableContainer
                      component={Paper}
                      sx={{
                        backgroundColor: "#000000",
                        padding: "10px",
                        borderRadius: "8px",
                      }}
                    >
                      <Table sx={{ minWidth: 650 }}>
                        <TableHead sx={{ backgroundColor: "#ffffff" }}>
                          <TableRow>
                            <TableCell>
                              <TableSortLabel
                                active={sortConfig.mTm.direction !== "asc"}
                                direction={sortConfig.mTm.direction}
                                onClick={() => handleSort("mTm")}
                              >
                                Measurement Time
                              </TableSortLabel>
                            </TableCell>

                            <TableCell>
                              <TableSortLabel
                                active={sortConfig.wtr.direction !== "asc"}
                                direction={sortConfig.wtr.direction}
                                onClick={() => handleSort("wtr")}
                              >
                                Water Level
                              </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>
                              <TableSortLabel
                                active={sortConfig.tmp.direction !== "asc"}
                                direction={sortConfig.tmp.direction}
                                onClick={() => handleSort("tmp")}
                              >
                                Temperature
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={sortConfig.prs.direction !== "asc"}
                                direction={sortConfig.prs.direction}
                                onClick={() => handleSort("prs")}
                              >
                                Pressure
                              </TableSortLabel>
                            </TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sortedDatalogs.map((datalog) => (
                            <TableRow
                              key={datalog.id}
                              sx={{
                                backgroundColor: "#1a1a1a", // Dark gray otherwise
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "#262626", // Slightly lighter gray otherwise
                                },
                              }}
                            >
                              <TableCell sx={{ color: "#ffffff" }}>
                                {formatDate(datalog.mTm)}
                              </TableCell>
                              <TableCell sx={{ color: "#ffffff" }}>
                                {datalog.wtr}
                              </TableCell>
                              {/* <TableCell sx={{ color: "#ffffff" }}>
                                {datalog.tmp}
                              </TableCell>
                              <TableCell sx={{ color: "#ffffff" }}>
                                {datalog.prs}
                              </TableCell> */}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  
                    </>   
     
  );
};
export default Datatable;